module.exports = __webpack_public_path__ + "static/media/91.14110e69.gif";